import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Box,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().required("Security name is required"),
  tickerSymbol: Yup.string().required("Ticker symbol is required"),
  cusip: Yup.string(),
  sedol: Yup.string(),
  isin: Yup.string(),
  figi: Yup.string(),
  bloomberg: Yup.string(),
  factset: Yup.string(),
});

const SecurityMasterDialog = ({ open, onClose, security, onSave }) => {
  const theme = useTheme();
  const isEdit = !!security;

  const initialValues = {
    name: security?.name || "",
    tickerSymbol: security?.ticker?.symbol || "",
    cusip: security?.cusip || "",
    sedol: security?.sedol || "",
    isin: security?.isin || "",
    figi: security?.figi || "",
    bloomberg: security?.bloomberg || "",
    factset: security?.factset || "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      onSave({
        ...values,
        id: security?.id,
      });
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        {isEdit ? "Edit Security" : "Add New Security"}
      </DialogTitle>
      
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="name"
                label="Security Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                required
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="tickerSymbol"
                label="Ticker Symbol"
                value={formik.values.tickerSymbol}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.tickerSymbol && Boolean(formik.errors.tickerSymbol)}
                helperText={formik.touched.tickerSymbol && formik.errors.tickerSymbol}
                required
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="cusip"
                label="CUSIP"
                value={formik.values.cusip}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.cusip && Boolean(formik.errors.cusip)}
                helperText={formik.touched.cusip && formik.errors.cusip}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="sedol"
                label="SEDOL"
                value={formik.values.sedol}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.sedol && Boolean(formik.errors.sedol)}
                helperText={formik.touched.sedol && formik.errors.sedol}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="isin"
                label="ISIN"
                value={formik.values.isin}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.isin && Boolean(formik.errors.isin)}
                helperText={formik.touched.isin && formik.errors.isin}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="figi"
                label="FIGI"
                value={formik.values.figi}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.figi && Boolean(formik.errors.figi)}
                helperText={formik.touched.figi && formik.errors.figi}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="bloomberg"
                label="Bloomberg"
                value={formik.values.bloomberg}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.bloomberg && Boolean(formik.errors.bloomberg)}
                helperText={formik.touched.bloomberg && formik.errors.bloomberg}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="factset"
                label="FactSet"
                value={formik.values.factset}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.factset && Boolean(formik.errors.factset)}
                helperText={formik.touched.factset && formik.errors.factset}
              />
            </Grid>
          </Grid>
        </DialogContent>
        
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button onClick={handleClose} color="inherit">
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            {isEdit ? "Update" : "Add"} Security
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default SecurityMasterDialog; 